export default __webpack_public_path__ + "static/media/Edit.bf2d1dbd.svg";